import { Button } from "./button.styled";

interface ButtonProps {
  children: React.ReactNode;
  action?: boolean;
  size?: "small" | "medium" | "large";
  fullWidth?: boolean;
  disabled?: boolean;
  type?: "button" | "submit" | "reset";
  onClick?: (e: React.MouseEvent<HTMLButtonElement>) => void;
  onFocus?: (e: React.FocusEvent<HTMLButtonElement>) => void;
  onBlur?: (e: React.FocusEvent<HTMLButtonElement>) => void;
  className?: string;
  style?: React.CSSProperties;
  marginTop?: number;
  marginRight?: number;
  marginBottom?: number;
  marginLeft?: number;
  alignRight?: boolean;
  width?: number;
}

export const ButtonComponent: React.FC<ButtonProps> = (props) => {
  return (
    <Button
      action={props.action}
      size={props.size}
      fullWidth={props.fullWidth}
      disabled={props.disabled}
      type={props.type}
      onClick={props.onClick}
      onFocus={props.onFocus}
      onBlur={props.onBlur}
      className={props.className}
      marginTop={props.marginTop}
      marginRight={props.marginRight}
      marginBottom={props.marginBottom}
      marginLeft={props.marginLeft}
      alignRight={props.alignRight}
      width={props.width}
    >
      {props.children}
    </Button>
  );
};
